export const MAX_LIMIT_FILES = 5;
export const MAX_FILE_SIZE = 200e6; // 200 MB
export const MIN_FILE_SIZE = 12e3; // 12 KB
